<div class="mapClass" leaflet [leafletOptions]="options" (leafletMapReady)="onMapReady($event)"></div>